const URL = "https://dailyscribble.onrender.com";
export default URL;
